export const siteStack = [
  {
    title: "Shape",
    value: "A static-first React SPA with structured local content and one serverless contact route. No database required.",
  },
  {
    title: "Frontend",
    value: "React 19 · TypeScript 7 · Vite 8 · React Router 7 · reusable component and data architecture.",
  },
  {
    title: "Interface",
    value: "Tailwind CSS 4 foundation · custom design tokens · light/dark themes · responsive editorial panels · native SVG diagrams.",
  },
  {
    title: "Interaction",
    value: "Scrollspy navigation · saved theme · project routes · searchable skills · accessible form states · reduced-motion support.",
  },
  {
    title: "Cloudflare",
    value: "Workers Static Assets · Worker API route · native email binding · optional Turnstile · Web Analytics ready.",
  },
  {
    title: "Delivery",
    value: "Git-based previews · npm production build · SPA fallback · environment secrets · custom-domain ready.",
  },
] as const;
